import { defineAsyncComponent } from 'vue'

const Asl = defineAsyncComponent(() => import('./asl.vue'))
const AslModal = defineAsyncComponent(() => import('./asl-modal.vue'))
const AslsSelect = defineAsyncComponent(() => import('./asls-select.vue'))
const AslsTable = defineAsyncComponent(() => import('./asls-table.vue'))

export { Asl, AslModal, AslsSelect, AslsTable }
